exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-container-3SHw8No4 {\n  display: flex;\n  z-index: 30;\n  position: absolute;\n}\n\n.styles-indicatorPill-12D9Oc8L {\n  border-width: 0;\n}\n\n.styles-selectedPill-2Ar572SE {\n}\n", ""]);

// exports
exports.locals = {
	"container": "styles-container-3SHw8No4",
	"indicatorPill": "styles-indicatorPill-12D9Oc8L",
	"selectedPill": "styles-selectedPill-2Ar572SE"
};